module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 114.843e9fb7.png";